import { track } from './event-handlers';
import { initializeConsentManager } from './consent-manager';

/** @type {import('vue').Plugin<[{ router: import('vue-router').Router }]>} */
const Tracker = {
  install(app, { router }) {
    const consentManager = initializeConsentManager();
    track.openConsentManager = consentManager.openConsentManager;

    app.config.globalProperties.$track = track;

    router.afterEach((to, from) => {
      const hasNavigated = Boolean(from.name);
      if (hasNavigated) {
        consentManager.implyConsent();
      }

      if (!to.meta.deferPageTracking) {
        track('page', { title: to.meta.title });
      }
    });
  },
};

export default Tracker;
export { track };
